import Marquee from 'react-fast-marquee';
import { Handshake, Building2, TrendingUp } from 'lucide-react';

const Partnerships = () => {
  const partnerCategories = [
    {
      title: "Food & Beverage Partners",
      description: "Premium food and hospitality brands enriching our events",
      icon: Building2,
      partners: [
        { name: "Bombay Belly & Co", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/a7f8x1ly_image-removebg-preview%20%2812%29.png" },
        { name: "Mayukh", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/60e4bube_image-removebg-preview%20%2815%29.png" },
        { name: "Ganga Bakery & Sweets", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/deqncvnu_image-removebg-preview%20%289%29.png" },
      ]
    },
    {
      title: "Automotive Partners",
      description: "Leading automotive brands supporting our entrepreneurial ecosystem",
      icon: TrendingUp,
      partners: [
        { name: "Suzuki", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/yps6lele_image-removebg-preview%20%2810%29.png" },
        { name: "Motor Company", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/vul1lifx_image-removebg-preview%20%288%29.png" },
        { name: "AMR", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/e2ybk2xu_image-removebg-preview%20%287%29.png" },
      ]
    },
    {
      title: "Technology & Fashion Partners",
      description: "Organizations driving innovation and growth",
      icon: Handshake,
      partners: [
        { name: "Microport", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/5yu6aozs_image-removebg-preview%20%2814%29.png" },
        { name: "Merkuri Fashion", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/z1ixmrlt_merkuri_fashion-removebg-preview.png" },
        { name: "MYOP", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/iybri1j8_image-removebg-preview%20%2811%29.png" },
        { name: "Partner", logo: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/cyk2kpgw_image-removebg-preview%20%2813%29.png" },
      ]
    }
  ];

  const allLogos = [
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/a7f8x1ly_image-removebg-preview%20%2812%29.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/cyk2kpgw_image-removebg-preview%20%2813%29.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/z1ixmrlt_merkuri_fashion-removebg-preview.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/5yu6aozs_image-removebg-preview%20%2814%29.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/60e4bube_image-removebg-preview%20%2815%29.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/e2ybk2xu_image-removebg-preview%20%287%29.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/vul1lifx_image-removebg-preview%20%288%29.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/deqncvnu_image-removebg-preview%20%289%29.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/yps6lele_image-removebg-preview%20%2810%29.png",
    "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/iybri1j8_image-removebg-preview%20%2811%29.png",
  ];

  return (
    <div className="pt-20" data-testid="partnerships-page">
      <section className="section-padding bg-gradient-to-b from-black to-[#121212]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-500 mb-4">BUILDING TOGETHER</p>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter uppercase mb-6" style={{ fontFamily: 'Open Sans' }}>OUR PARTNERS</h1>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">We're grateful to our partners who share our vision of fostering entrepreneurship and innovation.</p>
          </div>

          <div className="mb-20">
            <Marquee gradient={false} speed={40} className="py-8">
              {allLogos.map((logo, index) => (
                <div key={index} className="mx-8 glass-card p-6 hover:border-gold-500/50 transition-all">
                  <img src={logo} alt={`Partner ${index + 1}`} className="h-16 opacity-70 hover:opacity-100 transition-opacity" />
                </div>
              ))}
            </Marquee>
          </div>

          <div className="space-y-16">
            {partnerCategories.map((category, index) => {
              const Icon = category.icon;
              return (
                <div key={index} data-testid={`partner-category-${index}`}>
                  <div className="flex items-center space-x-4 mb-8">
                    <Icon className="text-gold-500" size={32} />
                    <div>
                      <h2 className="text-3xl font-black" style={{ fontFamily: 'Open Sans' }}>{category.title}</h2>
                      <p className="text-gray-400">{category.description}</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {category.partners.map((partner, pIndex) => (
                      <div key={pIndex} className="glass-card p-8 flex items-center justify-center hover:scale-105 transition-transform" data-testid={`partner-card-${index}-${pIndex}`}>
                        <img src={partner.logo} alt={partner.name} className="max-w-full h-auto opacity-80 hover:opacity-100 transition-opacity" />
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-24 glass-card p-12 text-center">
            <h2 className="text-3xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>BECOME A PARTNER</h2>
            <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">Interested in partnering with KAROBAR? Let's collaborate to create meaningful opportunities for student entrepreneurs.</p>
            <a href="mailto:karobar.dps@christuniversity.in" className="btn-primary inline-block" data-testid="partner-with-us-button">
              PARTNER WITH US
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partnerships;